import React, { useCallback, useState } from 'react';
import { Header } from 'common/components/Header';
import {
  BusinessPartnerRegisterDoctorForm,
  BusinessPartnerRegisterDoctorFormModel,
} from 'pages/BusinessPartnerManagement/BusinessPartnerDoctorsManagement/BusinessPartnerRegisterDoctorPage/BusinessPartnerRegisterDoctorForm';
import { FormikOnSubmit } from 'lib/formik.utils';
import { BusinessPartnerContext } from 'pages/BusinessPartnerManagement/BusinessPartnerContext';
import { useMutation, useQueryCache } from 'react-query';
import { BusinessPartnersAPI } from 'api/BusinessPartnersAPI';
import { QueryKey } from 'api/queryKey';
import { message } from 'antd';
import { useEnsureContext } from 'common/hooks';
import { useHistory } from 'react-router';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { BusinessPartnerRoutes } from 'pages/BusinessPartnerManagement/businessPartnerRoutes';

export const BusinessPartnerRegisterDoctorPage = () => {
  const bpContext = useEnsureContext(BusinessPartnerContext);
  const queryCache = useQueryCache();

  const [mutate, { isLoading }] = useMutation(
    BusinessPartnersAPI.registerNewDoctor
  );

  const [mutateuserPermissions] = useMutation(
    BusinessPartnersAPI.updateUserPermissions
  );

  const [checkedDenyAccess, setCheckedDenyAccess] = useState(false);

  const permissionItems = [
    {
      permission: 'DIAGNOSIS',
      scope: checkedDenyAccess ? 'OWN' : 'PARTNER',
      enabled: true,
      read: true,
      create: true,
      update: true,
      delete: true,
    },
  ];

  const history = useHistory();
  const intlMessage = useFormatMessage();

  const removeSpacesFromForm = (
    formData: BusinessPartnerRegisterDoctorFormModel
  ) => {
    formData.phoneNumber = formData.phoneNumber

      .replace(/\s/g, '')
      .replace(/^0+/, '');
    formData.prefixCode = formData.prefixCode.replace(/\s/g, '');
    return formData;
  };

  const handleSubmit: FormikOnSubmit<BusinessPartnerRegisterDoctorFormModel> = useCallback(
    (formData, { resetForm }) => {
      const formDataToSend =
        formData.phoneNumber !== null
          ? removeSpacesFromForm(formData)
          : formData;

      mutate(
        {
          businessPartnerId: formDataToSend.partner
            ? formDataToSend.partner
            : bpContext.id,
          dto: formDataToSend,
        },
        {
          onSuccess: (res) => {
            checkedDenyAccess &&
              mutateuserPermissions({
                userId: res.userId,
                items: permissionItems,
              });
            resetForm();
            queryCache
              .invalidateQueries(QueryKey.BusinessPartnerDoctorsList)
              .then();
            message.success(
              intlMessage(
                { id: 'doctors.register.success' },
                {
                  firstName: formData.firstName,
                  lastName: formData.lastName,
                }
              )
            );
            history.push(`../${BusinessPartnerRoutes.Doctors}`);
          },
        }
      ).then();
    },
    [
      bpContext,
      mutate,
      queryCache,
      intlMessage,
      history,
      checkedDenyAccess,
      mutateuserPermissions,
      permissionItems,
    ]
  );

  return (
    <>
      <Header title={intlMessage({ id: 'doctors.new' })} />
      <BusinessPartnerRegisterDoctorForm
        onSubmit={handleSubmit}
        loading={isLoading}
        setCheckedDenyAccess={setCheckedDenyAccess}
      />
    </>
  );
};
